/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import {
  BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, LabelList
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../../utils/helpers';

const RevenueFromSubMonthBarChart = ({
  dir, subscribedMonthWise, showTitle, monthsBetweenDates,
  unsubscribedMonthWise, height,
  index
}) => {

  const [color1, color2] = colorsCombination[(showTitle ? index + 1 : index + 2) % 10];


  const dataToShow = []

  for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    const [year, month] = monthsBetweenDates?.[i]?.split('-');
    const unsubscribedMonthWiseAmount = unsubscribedMonthWise?.[month]?.reduce((acc, item) => Number(Number(Number(acc) + Number(item.amount)).toFixed(2)), 0) ?? 0;
    const subscribedMonthWiseAmount = subscribedMonthWise?.[month]?.reduce((acc, item) => Number(Number(Number(acc) + Number(item.amount)).toFixed(2)), 0) ?? 0;

    dataToShow.push({
      "Normal Order": unsubscribedMonthWiseAmount,
      "Subscribed Order": subscribedMonthWiseAmount,
      "month": `${month}-${year}`
    })
  }

  return (
    <Col xs={12}>

      {showTitle ? <div className="card__title">
        <h5 className="bold-text">Subscription Sales</h5>
      </div> : null}
      <div dir="ltr">
        <ResponsiveContainer height={height}>
          <BarChart
            data={dataToShow}
            margin={{
              top: 25, right: 0, left: 25, bottom: 0,
            }}
          >
            <XAxis dataKey="month" reversed={dir === 'rtl'} />
            <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
              tickFormatter={item => setCurrencyFormat(item, true)}
              width={90}
              allowDataOverflow
            />
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <Tooltip formatter={value => setCurrencyFormat(value, true)} />
            <Legend />
            <Bar stackId="1" type="monotone" dataKey="Subscribed Order" fill={color1 || '#3366ff'}>
              <LabelList
                fill="#FFF"
                position="insideTop"
                valueAccessor={(entry) => {
                  const perc = (entry["Subscribed Order"] + entry["Normal Order"]) ? Number((entry["Subscribed Order"] / (entry["Subscribed Order"] + entry["Normal Order"])) * 100).toFixed(2) : 0
                  return showTitle ? entry["Subscribed Order"] : `${perc || 0}%`
                }}
                formatter={item => setCurrencyFormat(item, showTitle)}
              />
            </Bar>
            <Bar stackId="1" type="monotone" dataKey="Normal Order" fill={color2 || "#39e600"}>
              {showTitle ? <LabelList
                fill="#FFF"
                position="insideTop"
                valueAccessor={entry => entry["Normal Order"]}
                formatter={item => setCurrencyFormat(item, true)}
              /> : null}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

    </Col>
  );
};

RevenueFromSubMonthBarChart.propTypes = {
  dir: PropTypes.string.isRequired,
  unsubscribedMonthWise: PropTypes.object.isRequired,
  subscribedMonthWise: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  showTitle: PropTypes.bool,
  monthsBetweenDates: PropTypes.arrayOf({}).isRequired,
  index: PropTypes.number,
};

RevenueFromSubMonthBarChart.defaultProps = {
  showTitle: true,
  index: 0
}

export default RevenueFromSubMonthBarChart;
